<div class="modalContainer">
    <div class="modal-header">
        <div class="modal-image">
            <img [src]="popUpData?.image" class="image-svg" alt="svg-image">
        </div>
        <div class="modal-title">{{ popUpData.title }}</div>
        <div class="modal-sub-title" [innerHTML]="popUpData.subTitle"></div>
    </div>

    <div class="modal-body">
        <ng-content select="[content]"></ng-content>
    </div>

    <div class="modal-footer">
        <button type="button" mat-stroked-button class="primary no-text-transform" *ngIf="popUpData.negativeButtonText"
            (click)="decline()">{{popUpData.negativeButtonText}}</button>

        <button type="button" mat-flat-button class="primary no-text-transform continue-button"
            [mat-dialog-close]="true" cdkFocusInitial>{{popUpData.positiveButtonText}}</button>
    </div>
</div>